import * as React from 'react'
import { Box, Chip, IconButton, Typography } from '@mui/material'
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import PseudonymActions from './Actions'

const PseudonymDetailCell = ({ row }) => {
  return (
    <Box sx={{ width: '100%', py: 1.5, pr: 2 }}>
      <Typography variant="body2" sx={{ fontWeight: 700, mb: 1 }}>
        Detalle del pseudónimo
      </Typography>

      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
        <Chip label={`ID pseudónimo: ${row.__parentId}`} size="small" color="primary" variant="outlined" />
        <Chip
          label={`ID especie: ${row.idEspecie ?? 'No disponible'}`}
          size="small"
          color="default"
          variant="outlined"
        />
      </Box>

      <Typography variant="body2" color="text.secondary">
        Especie: {row.nombre_cientifico || 'No disponible'}
      </Typography>
    </Box>
  )
}

export const getColumns = (rowId, setRowId, expandedRowIds, onToggleRow, onRequestDelete) => {
  const columns = [
    {
      field: '__expand',
      headerName: '',
      headerAlign: 'center',
      align: 'center',
      width: 54,
      minWidth: 54,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      disableExport: true,
      cellClassName: params => (params.row?.__isDetail ? 'pseudonym-detail-cell' : 'pseudonym-expand-cell'),
      renderCell: params => {
        if (params.row?.__isDetail) {
          return <PseudonymDetailCell row={params.row} />
        }

        const isExpanded = expandedRowIds.includes(params.row.id)
        return (
          <IconButton
            size="small"
            aria-label={isExpanded ? 'Contraer detalle' : 'Expandir detalle'}
            onClick={event => {
              event.stopPropagation()
              onToggleRow(params.row.id)
            }}>
            {isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        )
      },
    },
    {
      field: 'nombre_comun',
      headerName: 'Nombre común',
      headerAlign: 'center',
      flex: 2,
      minWidth: 180,
      editable: true,
    },
    {
      field: 'habilitado',
      headerAlign: 'center',
      headerName: 'Habilitado',
      type: 'boolean',
      flex: 1,
      minWidth: 120,
      editable: true,
    },
    {
      field: 'estado_validacion',
      headerName: 'Estado verificado',
      headerAlign: 'center',
      align: 'center',
      type: 'singleSelect',
      editable: true,
      valueOptions: [
        { value: 'pendiente', label: 'Pendiente' },
        { value: 'verificado', label: 'Verificado' },
      ],
      flex: 1.6,
      minWidth: 170,
      valueFormatter: params => {
        if (params?.value === 'verificado') return 'Verificado'
        if (params?.value === 'pendiente') return 'Pendiente'
        return 'No definido'
      },
    },
    {
      field: 'actions',
      headerAlign: 'center',
      headerName: 'Acciones',
      type: 'actions',
      renderCell: params =>
        params.row?.__isDetail ? null : <PseudonymActions {...{ params, rowId, setRowId, onRequestDelete }} />,
      minWidth: 130,
      flex: 1,
    },
  ]

  const totalColumns = columns.length
  columns[0].colSpan = params => (params.row?.__isDetail ? totalColumns : 1)

  return columns
}
